import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from 'pages/home';
import ReceiptImageTab from 'pages/ReceiptImageTab';
import { AuthCallback } from 'pages/auth';
import ErrorBoundary from 'components/ErrorBoundary';
import { useAuthInit } from 'stores/authStore';
import { ROUTES } from 'utils/constants';
import AuthenticatedRoutes from 'components/AuthenticatedRoutes';
import ScrollToTopButton from 'components/ScrollToTopButton';
import PageTitle from 'components/PageTitle';
import CommandPalette from 'components/CommandPalette';
import PublicWebsiteByDomainSlugRoute from 'pages/Membership/WebsiteBuilder/PublicWebsiteByDomainSlugRoute';
import {
  useCommandPaletteStore,
  useCommandPaletteShortcut,
} from 'stores/commandPaletteStore';
import { useCompanyAliasUrlSync } from 'hooks/useCompanyAliasUrlSync';

function App() {
  useAuthInit();
  useCommandPaletteShortcut();
  useCompanyAliasUrlSync();

  const location = useLocation();
  const isReceiptImageOnlyTab = location.pathname === ROUTES.RECEIPT_IMAGE_TAB;

  const isPaletteOpen = useCommandPaletteStore((s) => s.isOpen);
  const closePalette = useCommandPaletteStore((s) => s.close);

  return (
    <ErrorBoundary>
      {!isReceiptImageOnlyTab && (
        <>
          <ScrollToTopButton />
          <PageTitle />
          <CommandPalette isOpen={isPaletteOpen} onClose={closePalette} />
        </>
      )}
      <Routes>
        <Route path={ROUTES.RECEIPT_IMAGE_TAB} element={<ReceiptImageTab />} />
        <Route path={ROUTES.AUTH_CALLBACK} element={<AuthCallback />} />
        <Route path={ROUTES.HOME} element={<Home />} />
        <Route
          path="www/:companyDomain/:slug"
          element={<PublicWebsiteByDomainSlugRoute />}
        />
        <Route path="/*" element={<AuthenticatedRoutes />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
